module.exports = __webpack_public_path__ + "img/sub_bg_m.b685dec1.png";